import { useBreadcrumb, useScrollTop } from "hooks"
import usePermission from "hooks/usePermission"
import { cn } from "lib/utils"
import { IRolePermissions } from "models/roles"

export interface PageLayoutProps {
  title: string
  permission?: keyof IRolePermissions
  children?: React.ReactNode
  className?: string
}

function PageLayout(props: PageLayoutProps) {
  useScrollTop()
  usePermission(props.permission)
  useBreadcrumb({
    title: props.title,
  })

  return (
    <div className={cn("flex justify-center mobile:overflow-auto mobile:h-screen mobile:pt-[60px] w-full", props.className)}>
      {props.children}
    </div>
  )
}

export default PageLayout
